import { takeEvery } from 'redux-saga/effects';

// internal
import * as Action from '@app/store/typings/actions/zone.d';
import { fetchCreate, fetchDataSelect, fetchZones } from './fetch';

export function* zoneSaga() {
  yield takeEvery(Action.KEY_ZONE_SELECT_FETCH, fetchDataSelect);
  yield takeEvery(Action.KEY_ZONE_FETCH, fetchZones);
  yield takeEvery(Action.KEY_ZONE_CREATE, fetchCreate);
}
